"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkInfoReasonWhenAdjusting = exports.GFAdjustPriceRangeWithoutBaseProcessor = exports.GFAdjustPriceRangeWithBaseProcessor = exports.GFAddPositionProcessor = exports.GFAdjustParamsBase = void 0;
const TradeAPILib_1 = require("TradeAPILib");
const trade_utils_lib_1 = require("trade_utils_lib");
const useAdjustParamsCheckInfo_1 = require("./Hooks/useAdjustParamsCheckInfo");
const interfaces_1 = require("./interfaces");
const react_1 = require("react");
const apis_1 = require("./apis");
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const GridV4FuturesProcessor_1 = require("./GridV4FuturesProcessor");
const GridTradingUtils_1 = require("../GridTradingUtils");
const lodash_1 = require("lodash");
const checkInvestInTriggerTPSL_1 = require("./Tools/checkInvestInTriggerTPSL");
/** 调整参数 基础封装 */
const GFAdjustParamsBase = (props) => {
    const { type, invest, curPrice, symbolInfo, balance, extraMargin, exchangeOrder, top, bottom, row, extraMarginAmount, $st, $num, isRecommend, isReinvest, condition, conditionDirection, aiSlippageValue, enableSlippage, } = props;
    const order = exchangeOrder.exchangeGridV4FuturesOrder;
    const available = trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(balance, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost);
    const { checkInfo, queryCheckInfo, queryCheckInfoWithExtraInfo, loading: checkLoading, previousPrice, } = (0, useAdjustParamsCheckInfo_1.useAdjustParamsCheckInfo)({
        quote_investment: invest,
        open_price: curPrice,
        orderId: exchangeOrder.id,
        extra_margin: extraMargin,
        type,
        precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost,
        top,
        bottom,
        row,
        extra_margin_amount: extraMarginAmount,
        is_recommend: isRecommend,
        is_reinvest: isReinvest,
        condition,
        condition_direction: conditionDirection,
    });
    let checkTPSLInfo;
    if (type === interfaces_1.AdjustParamsType.invest_in_trigger) {
        checkTPSLInfo = (0, checkInvestInTriggerTPSL_1.checkInvestInTriggerTPSL)({ order, condition });
    }
    const submit = (0, react_1.useCallback)((investParam, isAdjustParam) => {
        return queryCheckInfo(investParam).pipe((0, operators_1.mergeMap)((info) => {
            if (info.check_result) {
                return (0, apis_1.adjustParamsAPI)({
                    quote_investment: investParam || invest || "0",
                    type,
                    orderId: exchangeOrder.id,
                    extra_margin: extraMargin,
                    open_price: curPrice || "",
                    top,
                    bottom,
                    row,
                    extra_margin_amount: extraMarginAmount || "0",
                    is_recommend: isRecommend,
                    is_reinvest: isReinvest,
                    condition,
                    condition_direction: conditionDirection,
                    slippage: enableSlippage ? aiSlippageValue !== null && aiSlippageValue !== void 0 ? aiSlippageValue : info === null || info === void 0 ? void 0 : info.slippage : undefined,
                });
            }
            if (isAdjustParam) {
                const r = checkInfoReasonWhenAdjusting({ reason: info === null || info === void 0 ? void 0 : info.reason, $st });
                if (r) {
                    // 修改区间带追加投资额可能出现的报错提示
                    return (0, rxjs_1.throwError)(r);
                }
            }
            else {
                const r = checkInfoReason({ reason: info === null || info === void 0 ? void 0 : info.reason, $st });
                if (r) {
                    // 加仓时的submit时的check可能出现的报错提示
                    return (0, rxjs_1.throwError)(r);
                }
            }
            // 理论上这行代码不会执行，因为checkInfoReason和checkInfoReasonWhenAdjusting 都添加了兜底的默认文案
            return (0, rxjs_1.throwError)({ code: -1, message: "check failed", data: info });
        }));
    }, [
        queryCheckInfo,
        invest,
        type,
        exchangeOrder.id,
        extraMargin,
        curPrice,
        top,
        bottom,
        row,
        extraMarginAmount,
        isRecommend,
        isReinvest,
        condition,
        conditionDirection,
        enableSlippage,
        aiSlippageValue,
        $st,
    ]);
    const submitWithInvestInfo = (0, react_1.useCallback)((investParam, extraMarginAmountParam, openPrice, isRecommendParam, isReinvestParam, isAdjustParam) => {
        return queryCheckInfoWithExtraInfo(investParam, extraMarginAmountParam, openPrice, isRecommendParam, isReinvestParam, isAdjustParam).pipe((0, operators_1.mergeMap)((info) => {
            if (info.check_result) {
                return (0, apis_1.adjustParamsAPI)({
                    quote_investment: investParam || "0",
                    type,
                    orderId: exchangeOrder.id,
                    extra_margin: extraMargin,
                    open_price: openPrice || "",
                    top,
                    bottom,
                    row,
                    extra_margin_amount: extraMarginAmountParam || "0",
                    is_recommend: isRecommendParam,
                    is_reinvest: isReinvestParam,
                    condition,
                    condition_direction: conditionDirection,
                });
            }
            if (isAdjustParam) {
                const r = checkInfoReasonWhenAdjusting({ reason: info === null || info === void 0 ? void 0 : info.reason, $st });
                if (r) {
                    // 修改区间带追加投资额可能出现的报错提示
                    return (0, rxjs_1.throwError)(r);
                }
            }
            else {
                const r = checkInfoReason({ reason: info === null || info === void 0 ? void 0 : info.reason, $st });
                if (r) {
                    // 非修改区间submit时的check可能出现的报错提示
                    return (0, rxjs_1.throwError)(r);
                }
            }
            // 理论上这行代码不会执行，因为checkInfoReason和checkInfoReasonWhenAdjusting 都添加了兜底的默认文案
            return (0, rxjs_1.throwError)({ code: -1, message: "check failed", data: info });
        }));
    }, [$st, bottom, exchangeOrder.id, extraMargin, queryCheckInfoWithExtraInfo, row, top, type]);
    return {
        checkInfo,
        checkLoading,
        checkTPSLInfo,
        submit,
        submitWithInvestInfo,
        available,
        previousPrice,
    };
};
exports.GFAdjustParamsBase = GFAdjustParamsBase;
// 获取不允许调整参数的原因
const checkInfoReason = ({ reason, $st }) => {
    switch (reason) {
        case interfaces_1.AdjustParamsCheckReason.MARGIN_NOT_ENOUGH: {
            return $st("gf_add_position_error_margin_not_enough");
        }
        case interfaces_1.AdjustParamsCheckReason.EXCEED_NOTIONAL_LIMIT: {
            return $st("gf_add_position_error_margin_notional_limit");
        }
        case interfaces_1.AdjustParamsCheckReason.LESS_THAN_MIN_INVESTMENT: {
            return $st("gf_add_position_error_less_than_min_investment");
        }
        case interfaces_1.AdjustParamsCheckReason.GREATE_THAN_MAX_INVESTMENT: {
            return $st("gf_add_position_error_greater_than_max_investment");
        }
        case interfaces_1.AdjustParamsCheckReason.NO_ADD_POSITION_QUOTA: {
            return $st("gf_add_position_error_no_quota");
        }
        case interfaces_1.AdjustParamsCheckReason.LESS_THAN_MIN_INVESTMENT_RECOMMEND: {
            return $st("gf_add_position_error_less_than_min_investment_recommend");
        }
        default: {
            return $st("gf_futures_check_default_error_msg") + `\nReason: ${reason}`;
        }
    }
};
// 获取不允许调整参数时检查接口的原因
const checkInfoReasonWhenAdjusting = ({ reason, $st }) => {
    switch (reason) {
        case interfaces_1.AdjustParamsCheckReason.LESS_THAN_MIN_INVESTMENT: {
            return $st("gf_adjust_error_less_than_min_investment");
        }
        case interfaces_1.AdjustParamsCheckReason.GREATE_THAN_MAX_INVESTMENT: {
            return $st("gf_adjust_error_greater_than_max_investment");
        }
        case interfaces_1.AdjustParamsCheckReason.PROFIT_LESS_THAN_ZERO: {
            return $st("gf_adjust_error_less_than_zero_when_reinvest");
        }
        case interfaces_1.AdjustParamsCheckReason.EXCEED_NOTIONAL_LIMIT: {
            return $st("gf_adjust_error_greater_than_max_investment");
        }
        default: {
            return $st("gf_futures_check_default_error_msg") + `\nReason: ${reason}`;
        }
    }
};
exports.checkInfoReasonWhenAdjusting = checkInfoReasonWhenAdjusting;
/** 加仓 */
const GFAddPositionProcessor = (props) => {
    const { invest: _invest, $st, $num, balance, symbolInfo, curPrice, convertingInfo, askMaxAva, exchangeOrder, type = interfaces_1.AdjustParamsType.invest_in, condition, } = props;
    const order = exchangeOrder.exchangeGridV4FuturesOrder;
    const invest = (0, react_1.useMemo)(() => {
        var _a;
        if (convertingInfo) {
            return new trade_utils_lib_1.SafeDecimal(_invest)
                .div(GridV4FuturesProcessor_1.GridV4FuturesProcessor.adjustPrice(convertingInfo.unitPrice + ""))
                .toDP((_a = convertingInfo.precision) !== null && _a !== void 0 ? _a : 5, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR)
                .toString();
        }
        return _invest;
    }, [_invest, convertingInfo]);
    const investInTrigger = type === interfaces_1.AdjustParamsType.invest_in_trigger
        ? {
            condition,
            conditionDirection: new trade_utils_lib_1.SafeDecimal(condition).gt(new trade_utils_lib_1.SafeDecimal(curPrice)) ? "1" : "-1",
        }
        : {};
    const result = (0, exports.GFAdjustParamsBase)(Object.assign(Object.assign(Object.assign({}, props), investInTrigger), { invest,
        type }));
    const { checkInfo, checkLoading } = result;
    const [minInvest, maxInvest] = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (!checkInfo) {
            return ["0", "0"];
        }
        if (convertingInfo) {
            const quotePrice = convertingInfo.unitPrice;
            const min_investment = new trade_utils_lib_1.SafeDecimal(checkInfo.min_investment)
                .toDP((_a = convertingInfo.precision) !== null && _a !== void 0 ? _a : 5, trade_utils_lib_1.SafeDecimal.ROUND_CEIL)
                .toString();
            const max_investment = new trade_utils_lib_1.SafeDecimal(checkInfo.max_investment)
                .toDP((_b = convertingInfo.precision) !== null && _b !== void 0 ? _b : 5, trade_utils_lib_1.SafeDecimal.ROUND_FLOOR)
                .toString();
            return [
                trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(GridV4FuturesProcessor_1.GridV4FuturesProcessor.calcMinQuote(min_investment, quotePrice + ""), convertingInfo.precision, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
                trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(GridV4FuturesProcessor_1.GridV4FuturesProcessor.calcMaxQuote(max_investment, quotePrice + "", askMaxAva !== null && askMaxAva !== void 0 ? askMaxAva : 100000), convertingInfo.precision),
            ];
        }
        return [
            trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(checkInfo.min_investment, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost, trade_utils_lib_1.SafeDecimal.ROUND_CEIL),
            trade_utils_lib_1.NumberCommonUtils.formatterDecimalToStr(checkInfo.max_investment, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost),
        ];
    }, [askMaxAva, checkInfo, convertingInfo, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precisionCost]);
    const investError = (0, react_1.useMemo)(() => {
        const investD = new trade_utils_lib_1.SafeDecimal(_invest);
        const maxD = new trade_utils_lib_1.SafeDecimal(maxInvest);
        const minD = new trade_utils_lib_1.SafeDecimal(minInvest);
        const quoteDisplay = convertingInfo ? convertingInfo.unit : symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay;
        if (!Number(_invest)) {
            return "";
        }
        if (Number(_invest) > Number(balance)) {
            return $st("not_enough_balance");
        }
        if (checkInfo) {
            if (investD.gt(maxD)) {
                return $st("trade_invest_need") + `≤${maxInvest}${quoteDisplay}`;
            }
            else if (investD.lt(minD)) {
                return $st("trade_invest_need") + `≥${minInvest}${quoteDisplay}`;
            }
        }
        return "";
    }, [$st, _invest, balance, checkInfo, convertingInfo, maxInvest, minInvest, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay]);
    const investErrorOutside = (0, react_1.useMemo)(() => {
        const maxD = new trade_utils_lib_1.SafeDecimal(maxInvest);
        const minD = new trade_utils_lib_1.SafeDecimal(minInvest);
        if (checkInfo) {
            let errorText = "";
            let errorType = undefined;
            if (maxD.lt(minD)) {
                errorText = $st("grid_position_margin_no_quota");
                errorType = "no_quota";
                return { errorText, errorType };
            }
            // if (checkInfo.reason === AdjustParamsCheckReason.MARGIN_NOT_ENOUGH) {
            //     errorText = $st("grid_position_margin_not_enough");
            //     errorType = "margin_not_enough";
            //     return { errorText, errorType };
            // }
        }
    }, [$st, checkInfo, maxInvest, minInvest]);
    const inputPlaceHolder = (0, react_1.useMemo)(() => {
        let t = $st("trade_investment");
        const quoteDisplay = convertingInfo ? convertingInfo.unit : symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay;
        const max = Number(maxInvest);
        const min = Number(minInvest);
        if (max && min && max > min) {
            t = t + ` (${minInvest}-${maxInvest} ${quoteDisplay})`;
        }
        return t;
    }, [$st, convertingInfo, maxInvest, minInvest, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay]);
    const enableCommit = Number(invest) > 0 && !investError && !investErrorOutside && !checkLoading;
    const submitAddPosition = (0, react_1.useCallback)((realInvest = invest) => {
        if (!realInvest || !Number(realInvest)) {
            return (0, rxjs_1.throwError)($st("trade_error_input_invest"));
        }
        if (!curPrice) {
            return (0, rxjs_1.throwError)($st("trade_query_ticker_error"));
        }
        return result.submit(realInvest);
    }, [$st, curPrice, invest, result]);
    const stopLossInfo = (0, react_1.useMemo)(() => {
        if (!checkInfo || !checkInfo.check_result) {
            return undefined;
        }
        if ((order === null || order === void 0 ? void 0 : order.loss_stop_type) !== TradeAPILib_1.GridStopType.profit_ratio) {
            return undefined;
        }
        if (new trade_utils_lib_1.SafeDecimal(order === null || order === void 0 ? void 0 : order.stop).lte(0)) {
            return undefined;
        }
        const _profitRatioOrigin = new trade_utils_lib_1.SafeDecimal(order.totalProfit).div(new trade_utils_lib_1.SafeDecimal(order === null || order === void 0 ? void 0 : order.totalCost));
        // 当前盈亏额 ÷ (当前投资额 + 加仓实际投资额）
        const _profitRatioAfterAddPosition = new trade_utils_lib_1.SafeDecimal(order.totalProfit).div(new trade_utils_lib_1.SafeDecimal(order === null || order === void 0 ? void 0 : order.totalCost).add(new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_investment)));
        let res = {
            profitRatioOrigin: _profitRatioOrigin.toFixed(),
            profitRatioAfterAddPosition: _profitRatioAfterAddPosition.toFixed(),
        };
        return res;
    }, [checkInfo, order === null || order === void 0 ? void 0 : order.loss_stop_type, order === null || order === void 0 ? void 0 : order.stop, order === null || order === void 0 ? void 0 : order.totalCost, order.totalProfit]);
    const stopLossRisk = (0, react_1.useMemo)(() => {
        if (!stopLossInfo) {
            return false;
        }
        // 利润率降至小于等于止损率比率的1.05倍后需要提示风险
        return new trade_utils_lib_1.SafeDecimal(stopLossInfo.profitRatioAfterAddPosition).lte(new trade_utils_lib_1.SafeDecimal(order === null || order === void 0 ? void 0 : order.stop).mul(1.05));
    }, [order === null || order === void 0 ? void 0 : order.stop, stopLossInfo]);
    return Object.assign(Object.assign({}, result), { submit: submitAddPosition, investError,
        investErrorOutside,
        inputPlaceHolder,
        enableCommit,
        stopLossInfo,
        stopLossRisk });
};
exports.GFAddPositionProcessor = GFAddPositionProcessor;
// 是否是一个可用的数字，或者能转换成数字的字符串，而不是 空字符串 null false 等等
const isAvailableNumber = (v) => {
    if (typeof v === "number" || "0" === v) {
        return true;
    }
    const n = Number(v);
    if (isNaN(n)) {
        return false;
    }
    return !!n;
};
/** 修改区间 */
const GFAdjustPriceRangeWithBaseProcessor = (props) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j;
    const { exchangeOrder, top, bottom, row, curPrice, symbolInfo, $st, $num, tradeApi, gridV4FuturesMinCount, gridV4FuturesMaxCount, result, invest, extraMarginAmount, isRecommend, isReinvest, actualInvestment, tpSlSettingCheckBuffer = {
        tp: 0.03,
        sl: -0.03,
    }, ignoreBufferCheck, } = props;
    const { checkInfo } = result;
    const innerOrder = exchangeOrder.exchangeGridV4FuturesOrder;
    const isNoTrend = (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trend) === TradeAPILib_1.GridFuturesTrend.no_trend;
    const isLong = (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trend) === TradeAPILib_1.GridFuturesTrend.long;
    const isShort = (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trend) === TradeAPILib_1.GridFuturesTrend.short;
    // 网格是 多单 还是 是空单, 因为中性网格当前持仓方向只能通过金额判断
    const isLongOrder = (0, react_1.useMemo)(() => new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.position).greaterThanOrEqualTo(0), [innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.position]);
    // 需要追加的投资额
    const additionalInvestment = (0, react_1.useMemo)(() => {
        if (!checkInfo)
            return "0";
        return new trade_utils_lib_1.SafeDecimal(invest).add(new trade_utils_lib_1.SafeDecimal(extraMarginAmount)).toString();
    }, [checkInfo, extraMarginAmount, invest]);
    const stopLossRisk = (0, react_1.useMemo)(() => {
        if (!checkInfo || !checkInfo.check_result) {
            return false;
        }
        if ((innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type) !== TradeAPILib_1.GridStopType.profit_amount && (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type) !== TradeAPILib_1.GridStopType.profit_ratio) {
            return false;
        }
        if (!isAvailableNumber(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stop)) {
            return false;
        }
        const lStop = new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stop);
        if ((innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type) === TradeAPILib_1.GridStopType.profit_ratio) {
            return lStop.gte(tpSlSettingCheckBuffer.sl);
        }
        if (!isAvailableNumber(actualInvestment)) {
            return false;
        }
        const lActualInvestment = new trade_utils_lib_1.SafeDecimal(actualInvestment);
        const res = lStop.div(lActualInvestment);
        if ((innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type) === TradeAPILib_1.GridStopType.profit_amount) {
            return res.gte(tpSlSettingCheckBuffer.sl);
        }
        return false;
    }, [actualInvestment, tpSlSettingCheckBuffer.sl, checkInfo, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stop]);
    const stopProfitRisk = (0, react_1.useMemo)(() => {
        if (!checkInfo || !checkInfo.check_result) {
            return false;
        }
        if ((innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.profit_stop_type) !== TradeAPILib_1.GridStopType.profit_amount && (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.profit_stop_type) !== TradeAPILib_1.GridStopType.profit_ratio) {
            return false;
        }
        if (!isAvailableNumber(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trailing)) {
            return false;
        }
        const lTrailing = new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trailing);
        if ((innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.profit_stop_type) === TradeAPILib_1.GridStopType.profit_ratio) {
            return lTrailing.gt(0) && lTrailing.lte(tpSlSettingCheckBuffer.tp);
        }
        if (!isAvailableNumber(actualInvestment)) {
            return false;
        }
        const lActualInvestment = new trade_utils_lib_1.SafeDecimal(actualInvestment);
        const res = lTrailing.div(lActualInvestment);
        if ((innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.profit_stop_type) === TradeAPILib_1.GridStopType.profit_amount) {
            return res.gt(0) && res.lte(tpSlSettingCheckBuffer.tp);
        }
        return false;
    }, [actualInvestment, tpSlSettingCheckBuffer.tp, checkInfo, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.profit_stop_type, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trailing]);
    const stopLossRiskWithLiq = (0, react_1.useMemo)(() => {
        if (!checkInfo)
            return false;
        const upAfter = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_up_after;
        const downAfter = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_down_after;
        if ((innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type) !== TradeAPILib_1.GridStopType.price && (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type) !== TradeAPILib_1.GridStopType.price_limit) {
            return false;
        }
        const stop = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stop;
        const stopHigh = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stopHigh;
        if (!(0, lodash_1.isNil)(stop) && isLong && new trade_utils_lib_1.SafeDecimal(downAfter).gte(new trade_utils_lib_1.SafeDecimal(stop))) {
            return true;
        }
        if (!(0, lodash_1.isNil)(stop) && isShort && new trade_utils_lib_1.SafeDecimal(upAfter).lte(new trade_utils_lib_1.SafeDecimal(stop))) {
            return true;
        }
        if (isNoTrend) {
            const isDownGtStopLoss = !(0, lodash_1.isNil)(stop) && new trade_utils_lib_1.SafeDecimal(downAfter).gte(new trade_utils_lib_1.SafeDecimal(stop));
            const isUpLtStopHigh = !(0, lodash_1.isNil)(stopHigh) && new trade_utils_lib_1.SafeDecimal(upAfter).lte(new trade_utils_lib_1.SafeDecimal(stopHigh));
            if (isDownGtStopLoss && isUpLtStopHigh) {
                return true;
            }
            else if (isDownGtStopLoss) {
                return true;
            }
            else if (isUpLtStopHigh) {
                return true;
            }
        }
        return false;
    }, [checkInfo, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stop, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stopHigh, isLong, isNoTrend, isShort]);
    // 强平价不利
    const liquidPriceAdversely = (0, react_1.useMemo)(() => {
        if (!checkInfo)
            return null;
        const upAfter = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_up_after;
        const downAfter = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_down_after;
        // 价格区间内
        const priceRangeCheck = () => {
            const isInPriceRange = (v) => {
                if (!top || !bottom || !v)
                    return false;
                return new trade_utils_lib_1.SafeDecimal(v).lessThan(new trade_utils_lib_1.SafeDecimal(top)) && new trade_utils_lib_1.SafeDecimal(v).greaterThan(new trade_utils_lib_1.SafeDecimal(bottom));
            };
            const isUpInPriceRange = isInPriceRange(upAfter);
            const isDownInPriceRange = isInPriceRange(downAfter);
            if ((isNoTrend && isUpInPriceRange && isDownInPriceRange) || (isLong && isDownInPriceRange) || (isShort && isUpInPriceRange)) {
                return $st("grid_futures_adjust_warn_price_range1");
            }
            if (isNoTrend && isUpInPriceRange) {
                return $st("grid_futures_adjust_warn_price_range2");
            }
            if (isNoTrend && isDownInPriceRange) {
                return $st("grid_futures_adjust_warn_price_range3");
            }
            return null;
        };
        // 止损价
        const stopLossCheck = () => {
            if (ignoreBufferCheck) {
                return null;
            }
            if ((innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type) !== TradeAPILib_1.GridStopType.price && (innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type) !== TradeAPILib_1.GridStopType.price_limit) {
                return null;
            }
            const stop = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stop;
            const stopHigh = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stopHigh;
            if (!(0, lodash_1.isNil)(stop) && isLong && new trade_utils_lib_1.SafeDecimal(downAfter).gte(new trade_utils_lib_1.SafeDecimal(stop))) {
                return $st("grid_futures_adjust_warn_stop1_v3");
            }
            if (!(0, lodash_1.isNil)(stop) && isShort && new trade_utils_lib_1.SafeDecimal(upAfter).lte(new trade_utils_lib_1.SafeDecimal(stop))) {
                return $st("grid_futures_adjust_warn_stop2_v3");
            }
            if (isNoTrend) {
                const isDownGtStopLoss = !(0, lodash_1.isNil)(stop) && new trade_utils_lib_1.SafeDecimal(downAfter).gte(new trade_utils_lib_1.SafeDecimal(stop));
                const isUpLtStopHigh = !(0, lodash_1.isNil)(stopHigh) && new trade_utils_lib_1.SafeDecimal(upAfter).lte(new trade_utils_lib_1.SafeDecimal(stopHigh));
                if (isDownGtStopLoss && isUpLtStopHigh) {
                    return $st("grid_futures_adjust_warn_stop3_v3");
                }
                else if (isDownGtStopLoss) {
                    return $st("grid_futures_adjust_warn_stop4_v3");
                }
                else if (isUpLtStopHigh) {
                    return $st("grid_futures_adjust_warn_stop5_v3");
                }
            }
            return null;
        };
        // 前后强平价对比
        const liquidPriceCheck = () => {
            const downCurrent = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_down;
            const upCurrent = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_liquidation_price_up;
            const downCheck = new trade_utils_lib_1.SafeDecimal(downAfter).gt(new trade_utils_lib_1.SafeDecimal(downCurrent));
            const upCheck = new trade_utils_lib_1.SafeDecimal(upAfter).lt(new trade_utils_lib_1.SafeDecimal(upCurrent));
            if (isLong && downCheck) {
                return $st("grid_futures_adjust_warn_liquid1");
            }
            if (isShort && upCheck) {
                return $st("grid_futures_adjust_warn_liquid2");
            }
            if (isNoTrend) {
                if (downCheck && upCheck) {
                    return $st("grid_futures_adjust_warn_liquid3");
                }
                else if (downCheck) {
                    return $st("grid_futures_adjust_warn_liquid4");
                }
                else if (upCheck) {
                    return $st("grid_futures_adjust_warn_liquid5");
                }
            }
            return null;
        };
        const tpSlImmediateTriggerCheck = () => {
            if (ignoreBufferCheck) {
                return null;
            }
            let content = "";
            if (stopLossRisk && stopProfitRisk) {
                content = $st("title_tp_sl");
            }
            else if (stopLossRisk) {
                content = $st("label_sl");
            }
            else if (stopProfitRisk) {
                content = $st("label_tp");
            }
            if (!content) {
                return null;
            }
            const stopLossCheckRes = stopLossCheck();
            if (stopLossCheckRes) {
                return $st("grid_futures_adjust_params_tpsl_trigger_warn2", { info: content });
            }
            else {
                return $st("grid_futures_adjust_params_tpsl_trigger_warn1", { info: content });
            }
        };
        return tpSlImmediateTriggerCheck() || stopLossCheck() || priceRangeCheck() || liquidPriceCheck();
    }, [
        $st,
        bottom,
        checkInfo,
        ignoreBufferCheck,
        innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.loss_stop_type,
        innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stop,
        innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.stopHigh,
        isLong,
        isNoTrend,
        isShort,
        stopLossRisk,
        stopProfitRisk,
        top,
    ]);
    // 亏损 类型， 盈亏， 仓位变化
    // 为null 表示没有亏损
    const loss = (0, react_1.useMemo)(() => {
        if (!checkInfo)
            return null;
        // type: direct - 直接亏损
        if (new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_profit).lt(0)) {
            // 预计造成的亏损
            const d = {
                position: checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_position,
                pnl: checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_profit,
                type: "direct",
            };
            return d;
        }
        // TODO: 间接亏损的逻辑需要重新梳理，这里先disable
        // type: indirect - 间接亏损
        // if (new SafeDecimal(checkInfo?.estimate_delta_profit).eq(0)) {
        //     if (
        //         (isLongOrder &&
        //             new SafeDecimal(checkInfo?.estimate_position_open_price_after).lt(new SafeDecimal(innerOrder?.avgOpenPrice))) ||
        //         (!isLongOrder &&
        //             new SafeDecimal(checkInfo?.estimate_position_open_price_after).gt(new SafeDecimal(innerOrder?.avgOpenPrice)))
        //     ) {
        //         // 做多网格间接亏损: 调整后的卖出均价 < 当前持仓的成本
        //         // 做空网格间接亏损: 调整后的买入均价 > 当前持仓的成本
        //         const d: { type?: "direct" | "indirect"; pnl?: string; position?: string } = {
        //             type: "indirect",
        //         };
        //         return d;
        //     }
        // }
        // 未造成亏损
        return null;
    }, [checkInfo]);
    // 根据亏损类型，获取亏损文案
    const lossTips = (0, react_1.useMemo)(() => {
        var _a, _b, _c, _d;
        if (!checkInfo || !loss)
            return null;
        if ((loss === null || loss === void 0 ? void 0 : loss.type) === "direct") {
            const incPosition = new trade_utils_lib_1.SafeDecimal(loss.position).gte(0);
            const p = {
                baseAmount: $num(new trade_utils_lib_1.SafeDecimal(loss.position).abs().toString(), {
                    precision: (_a = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount) !== null && _a !== void 0 ? _a : 8,
                    rounding: !incPosition ? "ceil" : "floor", // 卖出仓位时向上取整卖的更多，买入仓位时向下取证买的更少。
                }),
                base: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay,
                quoteAmount: $num(new trade_utils_lib_1.SafeDecimal(loss.pnl).abs().toString(), {
                    precision: (_b = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _b !== void 0 ? _b : 8,
                    rounding: "ceil", // 向上取整使得显示的亏损的更多
                }),
                quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay,
            };
            return isLongOrder ? $st("grid_futures_adjust_warn_price_loss_long", p) : $st("grid_futures_adjust_warn_price_loss_short", p);
        }
        else if ((loss === null || loss === void 0 ? void 0 : loss.type) === "indirect") {
            const p = {
                avgAfter: $num(new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_position_open_price_after).toString(), {
                    precision: (_c = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _c !== void 0 ? _c : 8,
                }) + ` ${symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay}`,
                avgCurrent: $num(new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.avgOpenPrice).toString(), { precision: (_d = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _d !== void 0 ? _d : 8 }) +
                    ` ${symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay}`,
            };
            return isLongOrder ? $st("grid_futures_adjust_warn_avg_loss_up", p) : $st("grid_futures_adjust_warn_avg_loss_down", p);
        }
        return null;
    }, [
        $num,
        $st,
        checkInfo,
        innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.avgOpenPrice,
        isLongOrder,
        loss,
        symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount,
        symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay,
        symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision,
        symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay,
    ]);
    // 根据亏损类型，获取参数确认页的亏损文案
    const lossTipsOnConfirmPage = (0, react_1.useMemo)(() => {
        var _a, _b;
        if (!checkInfo || !loss)
            return null;
        if ((loss === null || loss === void 0 ? void 0 : loss.type) === "direct") {
            const p = {
                baseAmount: $num(new trade_utils_lib_1.SafeDecimal(loss.position).abs().toString(), {
                    precision: (_a = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount) !== null && _a !== void 0 ? _a : 8,
                    rounding: "ceil", // 向上取整使得显示的要卖的更多
                }),
                base: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay,
                quoteAmount: $num(new trade_utils_lib_1.SafeDecimal(loss.pnl).abs().toString(), {
                    precision: (_b = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _b !== void 0 ? _b : 8,
                    rounding: "ceil", // 向上取整使得显示的亏损的更多
                }),
                quote: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay,
            };
            return $st("grid_futures_adjust_warn_price_loss_on_confirm", { quoteAmount: p.quoteAmount, quote: p.quote });
        }
        // } else if (loss?.type === "indirect") {
        //     const p = {
        //         avgAfter:
        //             formatNum(new SafeDecimal(checkInfo?.estimate_position_open_price_after).toString(), {
        //                 decimal: symbolInfo?.precision ?? 8,
        //             }) + ` ${symbolInfo?.quoteDisplay}`,
        //         avgCurrent:
        //             formatNum(new SafeDecimal(innerOrder?.avgOpenPrice).toString(), { decimal: symbolInfo?.precision ?? 8 }) +
        //             ` ${symbolInfo?.quoteDisplay}`,
        //     };
        //     return isLongOrder ? $st("grid_futures_adjust_warn_avg_loss_up", p) : $st("grid_futures_adjust_warn_avg_loss_down", p);
        // }
        return null;
    }, [$num, $st, checkInfo, loss, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.quoteDisplay]);
    // 推荐参数提示
    const getRecommendTips = (0, react_1.useMemo)(() => {
        const p = { base: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay };
        return isLongOrder ? $st("grid_futures_adjust_recommend_long", p) : $st("grid_futures_adjust_recommend_short", p);
    }, [$st, isLongOrder, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay]);
    // 确认弹窗 仓位变更提示
    const positionChangeTips = (0, react_1.useMemo)(() => {
        const baseAmount = new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_position);
        const incPosition = new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_position).gte(0);
        const p = {
            baseAmount: $num(baseAmount.abs().toString(), { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount, rounding: !incPosition ? "ceil" : "floor" }),
            base: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay,
        };
        return incPosition ? $st("grid_futures_adjust_add_position_long", p) : $st("grid_futures_adjust_add_position_short", p);
    }, [$num, $st, checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_position, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount, symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay]);
    // 加仓明细
    const addPositionDetail = (0, react_1.useMemo)(() => {
        if (!checkInfo)
            return null;
        const baseAmount = new trade_utils_lib_1.SafeDecimal(checkInfo.estimate_delta_position);
        const isBuy = baseAmount.gt(0);
        const isSell = baseAmount.lt(0);
        const params = {
            baseAmount: $num(baseAmount.abs().toString(), { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount, rounding: isSell ? "ceil" : "floor" }),
            base: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay,
        };
        const baseText = isBuy
            ? $st("grid_futures_adjust_add_position_long", params)
            : isSell
                ? $st("grid_futures_adjust_add_position_short", params)
                : "";
        return {
            total: additionalInvestment,
            extraMargin: $num(extraMarginAmount, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }),
            investment: $num(invest, { precision: symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision }),
            baseText,
        };
    }, [
        checkInfo,
        $num,
        symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.amount,
        symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.baseDisplay,
        symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision,
        $st,
        additionalInvestment,
        extraMarginAmount,
        invest,
    ]);
    // 获取调整前后 base 占比
    const getBaseProportion = (0, react_1.useCallback)(() => {
        if (!checkInfo)
            return null;
        // 调整前的持仓
        const currentPosition = new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.position);
        // 当前quote转换成base的价值
        const currentQuote = new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.quoteAmount)
            .div(new trade_utils_lib_1.SafeDecimal(curPrice))
            .mul(new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.leverage));
        // 调整后的持仓
        const afterPosition = new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_position).add(new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.position));
        // 调整后quote转换成base的价值
        const afterQuote = new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_investment)
            .div(new trade_utils_lib_1.SafeDecimal(curPrice))
            .mul(new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.leverage))
            .sub(new trade_utils_lib_1.SafeDecimal(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.estimate_delta_position))
            .add(currentQuote);
        return {
            beforePercent: currentPosition.abs().div(currentPosition.abs().add(currentQuote)).mul(100).toFixed(2),
            afterPercent: afterPosition.abs().div(afterPosition.abs().add(afterQuote)).mul(100).toFixed(2),
        };
    }, [checkInfo, curPrice, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.leverage, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.position, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.quoteAmount]);
    const [fee] = GridTradingUtils_1.GridTradingUtils.useFeeRate(symbolInfo, tradeApi, TradeAPILib_1.ExchangeID.PIONEXV2, "maker");
    // 每格利润
    const profitPerGrid = GridTradingUtils_1.GridTradingUtils.useProfitPerGrid((_a = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.gridType) !== null && _a !== void 0 ? _a : "arithmetic", top || "", bottom || "", (row === null || row === void 0 ? void 0 : row.toString()) || "", fee, (_b = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _b !== void 0 ? _b : 0);
    const profitPerGridAfter = GridTradingUtils_1.GridTradingUtils.useProfitPerGrid((_c = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.gridType) !== null && _c !== void 0 ? _c : "arithmetic", ((_d = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.recommend) === null || _d === void 0 ? void 0 : _d.top) || "", ((_e = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.recommend) === null || _e === void 0 ? void 0 : _e.bottom) || "", ((_f = checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.recommend) === null || _f === void 0 ? void 0 : _f.row.toString()) || "", fee, (_g = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _g !== void 0 ? _g : 0);
    const calcuGridsMax = GridTradingUtils_1.GridTradingUtils.useRealMaxGridCount(top || "", bottom || "", (_h = innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.gridType) !== null && _h !== void 0 ? _h : "arithmetic", fee, (_j = symbolInfo === null || symbolInfo === void 0 ? void 0 : symbolInfo.precision) !== null && _j !== void 0 ? _j : 0, gridV4FuturesMaxCount !== null && gridV4FuturesMaxCount !== void 0 ? gridV4FuturesMaxCount : GridV4FuturesProcessor_1.GridV4FuturesMaxGrids);
    const tipsText = (0, react_1.useMemo)(() => {
        return {
            liquidPriceAdversely,
            cannotAdjust: !(checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.check_result) && (checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reason) ? checkInfoReasonWhenAdjusting({ reason: checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reason, $st }) : "",
            loss: lossTips,
            lossTipsOnConfirmPage: lossTipsOnConfirmPage,
            recommendTips: getRecommendTips,
            positionChangeTips, // 调仓的文案
        };
    }, [liquidPriceAdversely, checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.reason, $st, lossTips, lossTipsOnConfirmPage, getRecommendTips, positionChangeTips]);
    const emptyErrors = (0, react_1.useMemo)(() => {
        const rowD = row ? new trade_utils_lib_1.SafeDecimal(row).toString() : "";
        return GridTradingUtils_1.GridTradingUtils.checkRequiredParamsEmpty(top, bottom, rowD);
    }, [top, bottom, row]);
    const commonError = (0, react_1.useMemo)(() => {
        // 空参数时不检查参数问题
        if (!bottom || !top || !row)
            return "";
        if (new trade_utils_lib_1.SafeDecimal(top).equals(new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.high)) &&
            new trade_utils_lib_1.SafeDecimal(bottom).equals(new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.low)) &&
            new trade_utils_lib_1.SafeDecimal(row).equals(new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.number))) {
            // 用户未改变参数, 则不允许提交
            return $st("grid_adjust_params_trading_params_equal");
        }
        // 价格区间检查
        const errorMessage = GridTradingUtils_1.GridTradingUtils.checkPriceRangeError(bottom, top, $st, innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trend, new trade_utils_lib_1.SafeDecimal(innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.initPrice).toString());
        if (errorMessage)
            return errorMessage;
        // 网格数量检查
        let minCount = gridV4FuturesMinCount !== null && gridV4FuturesMinCount !== void 0 ? gridV4FuturesMinCount : 2;
        let maxCount = calcuGridsMax !== null && calcuGridsMax !== void 0 ? calcuGridsMax : GridV4FuturesProcessor_1.GridV4FuturesMaxGrids;
        if (new trade_utils_lib_1.SafeDecimal(row).lt(minCount) || new trade_utils_lib_1.SafeDecimal(row).gt(maxCount)) {
            return $st("grid_count_range_wrong", { min: gridV4FuturesMinCount, max: calcuGridsMax });
        }
        // 调整后的每格利润检查
        if (profitPerGrid && (profitPerGrid === null || profitPerGrid === void 0 ? void 0 : profitPerGrid.length) > 0 && new trade_utils_lib_1.SafeDecimal(profitPerGrid[0]).lessThan(0)) {
            return $st("grid_error_profit_per_grid_is_zero");
        }
        return "";
    }, [
        $st,
        bottom,
        calcuGridsMax,
        gridV4FuturesMinCount,
        innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.high,
        innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.initPrice,
        innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.low,
        innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.number,
        innerOrder === null || innerOrder === void 0 ? void 0 : innerOrder.trend,
        profitPerGrid,
        row,
        top,
    ]);
    const submitAdjustPriceRange = (0, react_1.useCallback)(() => {
        if (!curPrice) {
            return (0, rxjs_1.throwError)($st("trade_query_ticker_error"));
        }
        if (emptyErrors && emptyErrors.length) {
            const errs = emptyErrors.map((e) => {
                return $st(e);
            });
            return (0, rxjs_1.throwError)($st("trade_input_param_please", { param: errs[0] }));
        }
        if (commonError) {
            return (0, rxjs_1.throwError)(commonError);
        }
        const investParam = invest || "0";
        const extraMarginAmountParam = extraMarginAmount || "0";
        const isAdjust = true;
        return result.submitWithInvestInfo(investParam, extraMarginAmountParam, curPrice, isRecommend, isReinvest, isAdjust);
    }, [$st, commonError, curPrice, emptyErrors, extraMarginAmount, invest, isRecommend, isReinvest, result]);
    return Object.assign(Object.assign({}, result), { isLongOrder,
        additionalInvestment,
        tipsText, canAdjust: checkInfo === null || checkInfo === void 0 ? void 0 : checkInfo.check_result, // 是否允许调整参数
        loss,
        profitPerGrid,
        profitPerGridAfter,
        addPositionDetail,
        getBaseProportion, submit: submitAdjustPriceRange, emptyErrors,
        commonError,
        calcuGridsMax,
        stopLossRisk,
        stopProfitRisk,
        stopLossRiskWithLiq });
};
exports.GFAdjustPriceRangeWithBaseProcessor = GFAdjustPriceRangeWithBaseProcessor;
const GFAdjustPriceRangeWithoutBaseProcessor = (props) => {
    var _a, _b;
    const result = (0, exports.GFAdjustParamsBase)(Object.assign(Object.assign({}, props), { type: interfaces_1.AdjustParamsType.adjust_params }));
    const base = (0, exports.GFAdjustPriceRangeWithBaseProcessor)(Object.assign(Object.assign({}, props), { result: result, invest: (_a = result.checkInfo) === null || _a === void 0 ? void 0 : _a.estimate_investment, extraMarginAmount: (_b = result.checkInfo) === null || _b === void 0 ? void 0 : _b.estimate_extra_margin }));
    return Object.assign(Object.assign({}, base), { result: result });
};
exports.GFAdjustPriceRangeWithoutBaseProcessor = GFAdjustPriceRangeWithoutBaseProcessor;
